import { Index } from "@agtech/core/utilities/AgTechUtilities";
import { AgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";
import { ApplicationRole, UserRoleAssignment, UserRoleAssignmentIndex } from "./OperationRoleData";

// Backed by SalesProject.API.Controllers/API/Operation/UsersController.cs (GET api/Operation/Users/Roles),
// which proxies IAccountsAppUserService.GetApplicationRolesAsync - the identity server is not
// called directly from here.
export const OperationDataGetRolesQuery: AgTechQuery<any, ApplicationRole[]> = {
    queryKey: () => ['OperationRoles'],
    query: (props) => {
        return props.http.getEntity<ApplicationRole[]>({
            request: 'Operation/Users/Roles'
        });
    },
    content: {
        loadingText: 'Loading roles...',
        failureText: 'Failed to load roles.'
    }
}

// Backed by GET api/Operation/Users/Roles/Assignments, which proxies
// IAccountsAppUserService.GetUserRoleAssignmentsAsync - one entry per user that currently has
// at least one role, grouped server-side from DAT.Accounts' flat per-(user, role) rows.
export const OperationDataGetRoleAssignmentsQuery: AgTechQuery<any, UserRoleAssignmentIndex> = {
    queryKey: () => ['OperationRoleAssignments'],
    query: (props) => {
        return props.http.getEntity<UserRoleAssignment[], UserRoleAssignmentIndex>({
            request: 'Operation/Users/Roles/Assignments',
            convert: assignments => Index(assignments, assignment => assignment.userId)
        });
    },
    content: {
        loadingText: 'Loading role assignments...',
        failureText: 'Failed to load role assignments.'
    }
}
